import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { useEvent } from 'react-use'
// import { useIOSOrientationFix } from '../../hooks/useIOSOrientationFix'
import { useStore } from '../../stores'

const AppLayout = observer(() => {
  const { applicationStore, notificationStore } = useStore()
  const setOffline = (): void => applicationStore.setIsOffline(true)
  const setOnline = (): void => applicationStore.setIsOffline(false)

  // useIOSOrientationFix()

  useEvent('offline', setOffline)
  useEvent('online', setOnline)

  return (
    <>
      <Outlet />
      <ToastContainer
        containerId="global"
        position={notificationStore.position}
        enableMultiContainer
        closeButton={false}
        limit={3}
        icon={false}
        hideProgressBar
        theme="dark"
      />
    </>
  )
})

export default AppLayout
